var hideBtn = function hideBtn() {
  if (location.pathname.includes('collections')) {
    var filterBtn = document.querySelector('.facet-filters accordion-list button');
    var clearBtn = document.querySelector('.clear-all--desktop');
    if (filterBtn && clearBtn) {
      filterBtn.addEventListener('click', function () {
        requestAnimationFrame(function () {
          var isActive = filterBtn.classList.contains('active');
          if (clearBtn) {
            clearBtn.classList.toggle('hide-btn', !isActive);
          }
        });
      });
    }
  }
};
export { hideBtn };